const cards = [
  {
    title: '秘密恋爱笔记',
    tag: '恋爱',
    desc: '高人气校园恋爱韩漫，甜到心坎的秘密恋情故事',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20romance%20cover%20art%20style%20featuring%20two%20characters%20in%20warm%20sunset%20lighting%20soft%20painterly%20background%20with%20cherry%20blossom%20petals%20gentle%20emotional%20atmosphere%20portrait%20orientation%20simple%20elegant%20composition%20clean%20minimal%20background&width=600&height=800&seq=card-kr-01&orientation=portrait',
  },
  {
    title: '剑与魔法纪元',
    tag: '奇幻',
    desc: '史诗级奇幻冒险，剑士与魔法师的热血传奇之旅',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20cover%20art%20featuring%20dynamic%20character%20pose%20with%20dramatic%20lighting%20effects%20warm%20golden%20and%20crimson%20color%20scheme%20clean%20background%20with%20subtle%20energy%20particles%20striking%20composition%20portrait%20orientation&width=600&height=800&seq=card-kr-02&orientation=portrait',
  },
  {
    title: '咖啡馆的午后',
    tag: '日常',
    desc: '治愈系日常韩漫，温暖咖啡馆里的人间百态',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%20style%20featuring%20cozy%20cafe%20scene%20with%20warm%20ambient%20lighting%20soft%20beige%20and%20brown%20tones%20peaceful%20everyday%20atmosphere%20simple%20clean%20background%20portrait%20orientation&width=600&height=800&seq=card-kr-03&orientation=portrait',
  },
  {
    title: '暗夜追踪者',
    tag: '悬疑',
    desc: '紧张刺激的悬疑推理，层层反转让你欲罢不能',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20mystery%20cover%20art%20featuring%20silhouetted%20figure%20in%20dramatic%20shadow%20lighting%20warm%20amber%20and%20dark%20contrast%20tones%20atmospheric%20suspenseful%20mood%20clean%20composition%20portrait%20orientation&width=600&height=800&seq=card-kr-04&orientation=portrait',
  },
  {
    title: '花都王朝',
    tag: '古风',
    desc: '华丽古风恋情，宫廷权谋与刻骨铭心的爱恨纠葛',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20fantasy%20cover%20art%20featuring%20elegant%20character%20in%20traditional%20inspired%20costume%20with%20warm%20earthy%20tones%20and%20gold%20accents%20soft%20misty%20background%20romantic%20atmosphere%20portrait%20orientation&width=600&height=800&seq=card-kr-05&orientation=portrait',
  },
  {
    title: '爆笑学园日常',
    tag: '搞笑',
    desc: '校园喜剧韩漫天花板，每一话都笑到停不下来',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20school%20life%20cover%20art%20featuring%20cheerful%20expressive%20character%20illustration%20bright%20warm%20colors%20coral%20and%20yellow%20tones%20clean%20simple%20background%20energetic%20youthful%20vibe%20portrait%20orientation&width=600&height=800&seq=card-kr-06&orientation=portrait',
  },
  {
    title: '灵界事务所',
    tag: '奇幻',
    desc: '超自然奇幻大作，人鬼之间的温情与冒险故事',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20fantasy%20cover%20art%20featuring%20mystical%20character%20with%20ethereal%20glowing%20effects%20warm%20golden%20light%20magical%20atmosphere%20dreamy%20soft%20background%20enchanting%20composition%20portrait%20orientation&width=600&height=800&seq=card-kr-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热门韩漫推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选全网最受欢迎的韩国漫画，即刻开启免费阅读之旅
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#cards"
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={`韩漫 - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-1 line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 text-sm font-medium rounded-md border border-background-200 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多作品
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}